export const intcmpMap = {
  leagues: {
    dataAttribute: "intcmp",
    team: "skysport_sportsdata_squadre_news-squadra",
    accordion: "skysport_sportsdata_squadre_competizione",
  },
  competitionCalendarAndResults: {
    intcmp: "skysport_sportsdata_calendario-risultati_null",
  },
  teamRanking: {
    dataAttribute: "intcmp",
    ranking: "skysport_sportsdata_squadre-classifiche-",
    value: "_null",
  },
  teamCalendarAndResults: {
    intcmp: "skysport_sportsdata_calendario-risultati_null",
  },
  teamLastNextMatch: {
    dataAttribute: "intcmp",
    lastMatch: "skysport_sportsdata_ultima-partita_null",
    nextMatch: "skysport_sportsdata_prossima-partita_null",
  },
  scorersRankingPlayerPage: {
    playerCard: "skysport_classifica-marcatori_card-giocatore_detail-link",
    playerTeam: "skysport_classifica-marcatori_logo-squadra_detail-link",
    playerList: "skysport_classifica-marcatori_nome-giocatore-list_detail-link",
    "serie-a_Calendar": "skysport_classifica-marcatori_calendario-serie-a_null",
    "champions-league_Calendar":
      "skysport_classifica-marcatori_calendario-champions-league_null",
  },
  competitionPredictedLineups: {
    intcmp: "skysport_sportsdata_disposizione-in-campo_null",
  },
  matchPredictedLineups: {
    intcmp: "skysport_sportsdata_lista-giocatori_null",
  },
  competitionBoard: {
    mainLink: "skysport_sportsdata_tabellone_main-link",
    detailLink: "skysport_sportsdata_tabellone_detail-link",
    calendarResult: "skysport_sportsdata_calendario-risultati_detail-link",
  },
};
